import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';

/**
 * Component that groups radios with different layout variants.
 */
var RadioGroupComponent = /** @class */ (function (_super) {
    __extends(RadioGroupComponent, _super);
    function RadioGroupComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radios = new Map();
        _this.currentFocused = -1;
        return _this;
    }
    Object.defineProperty(RadioGroupComponent.prototype, "radioElements", {
        get: function () {
            return Array.from(this.radios.values());
        },
        enumerable: false,
        configurable: true
    });
    RadioGroupComponent.prototype.register = function (e) {
        var radio = e.detail[0];
        this.radios.set(radio.value, radio);
        radio.checked = this.value === radio.value;
    };
    RadioGroupComponent.prototype.valueChanged = function (newValue, oldValue) {
        if (newValue !== oldValue) {
            this.select(this.value);
        }
    };
    RadioGroupComponent.prototype.change = function (e) {
        var value = e.detail[0];
        this.select(value);
        return value;
    };
    RadioGroupComponent.prototype.select = function (value) {
        this.radios.forEach(function (el) {
            el.checked = el.value === value;
        });
    };
    RadioGroupComponent.prototype.setFocused = function (target) {
        this.currentFocused = this.radioElements.findIndex(function (radio) {
            return radio === target;
        });
    };
    RadioGroupComponent.prototype.focusCurrent = function (_a) {
        var target = _a.target;
        if (target) {
            this.setFocused(target);
        }
    };
    RadioGroupComponent.prototype.moveFocus = function (amount, event) {
        if (this.currentFocused === -1) {
            return;
        }
        var index = this.currentFocused + amount;
        var items = this.radioElements;
        if (!items.length) {
            return;
        }
        if (index < 0) {
            index = items.length - 1;
        }
        if (index >= items.length) {
            index = 0;
        }
        event.preventDefault();
        items.forEach(function (el, i) {
            el.focused = i === index;
        });
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], RadioGroupComponent.prototype, "selected", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioGroupComponent.prototype, "space", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioGroupComponent.prototype, "left", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioGroupComponent.prototype, "inline", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioGroupComponent.prototype, "inlineNowrap", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioGroupComponent.prototype, "column", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], RadioGroupComponent.prototype, "value", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioGroupComponent.prototype, "right", void 0);
    __decorate([
        Watch('value', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], RadioGroupComponent.prototype, "valueChanged", null);
    __decorate([
        Emit('changed'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [CustomEvent]),
        __metadata("design:returntype", void 0)
    ], RadioGroupComponent.prototype, "change", null);
    RadioGroupComponent = __decorate([
        Component({
            name: 'ui-radio-group',
        })
    ], RadioGroupComponent);
    return RadioGroupComponent;
}(Mixins(MagicConfigMixin)));

export default RadioGroupComponent;
